import PocEdit from './PocEdit'
import PocCreate from './PocCreate'
import PocList from './PocList'
import { PocDescriptor } from 'poc/factory'
import { apiMocker } from 'poc/apiMock'

type Model = {
  id: number
  title: string
}

const MOCK: Model[] = [
  {
    id: 1,
    title: 'test',
  },
]

const cfg: PocDescriptor = {
  dp: apiMocker(MOCK),
  forms: { list: PocList, edit: PocEdit, create: PocCreate },
}

export default cfg
